var $3052f4371a02e207$exports = {};
$3052f4371a02e207$exports = {
    "maximum": `Najvi\u{161}e`,
    "minimum": `Najmanje`
};


export {$3052f4371a02e207$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
